module.exports = __webpack_public_path__ + "static/media/workwithus.aced673a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/workwithus.svg
// module id = 141
// module chunks = 0